import { render, staticRenderFns } from "./business.vue?vue&type=template&id=fd910918&scoped=true"
import script from "./business.vue?vue&type=script&lang=ts"
export * from "./business.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd910918",
  null
  
)

export default component.exports